import { gql } from '@apollo/client';

export default gql`
  query getFinances($start: Date, $end: Date, $search: String) {
    getFinances(start: $start, end: $end, search: $search) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo
        opType
        time
        title
        desc

        contractId
        contractName
        contractNameAr

        customerId
        customerName
        customerNameAr
        customerPhone

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr

        resourseId
        resourseName
        resourseNameAr

        contractId
        contractName
        contractNameAr

        refNo
        refType

        amount

        debitAcc
        debitAccName
        debitAccNameAr
        creditAcc
        creditAccName
        creditAccNameAr

        manualInvNo
        manualRecNo
        manualOrdNo

        chequeBank
        chequeNo
        chequeDate

        procs

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
